"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShoppingCartOutline = {
    name: 'shopping-cart',
    theme: 'outline',
    nameWithTheme: 'shopping-cart-o',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4-6.5-7.8-16.2-12.4-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5c-19.4 0-35.3 15.8-35.3 35.3 0 19.5 15.8 35.3 35.3 35.3h125.9L246 312.8l58.1 281.3-74.8 122.1c-7.9 10.7-9.1 24.8-3 36.8 6 11.9 18.1 19.4 31.5 19.4h62.8C307.3 790 300 811.7 300 834.1c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1c-13.3 17.6-20.6 39.3-20.6 61.7 0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3-.1-19.4-15.9-35.2-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6c0 17.5-14.2 31.6-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6c0 17.5-14.2 31.6-31.6 31.6z'
            },
            children: []
        }
    ]
};
exports.default = ShoppingCartOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/outline/ShoppingCartOutline.js
// module id = 813
// module chunks = 0 1